<template>
	<div @click="close" class="wx-guide-popup" v-show="popupVisible">
		<mt-popup v-model="popupVisible" pop-transition="popup-fade" closeOnClickModal=false>
			<div>
				<h2>如何查看微信号?</h2>
				<p class="tips">进入微信APP, 找到“个人信息”页，就可以看到微信号</p>
				<p class="tips">如微信号是空的，请您马上进行设置，以享受更便利的服务</p>
				<p>
					<img src="/static/img/wx-guide01.png" class="img-responsive" />
				</p>    
			</div>    
		</mt-popup>
	</div>
</template>

<script>
	import { Popup } from 'mint-ui'
	export default{
		name: 'WxIdGuide',
		components: {
			'mt-popup': Popup
		},
		data: () => ({
			'popupVisible': false
		}),
		created () {
		},
		methods: {
			open () {
				this.popupVisible = true
			},
			close () {
				this.popupVisible = false
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/WxIdGuide.vue